import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spin, Space } from "antd";
import { createContext, useState } from "react";
import { useAuthentication } from "./utils/useAuthentication";
import { EAuth } from "@timeedit/types/lib/enums";
import "./AuthWrapper.scss";
export const AuthContext = createContext({
    authState: EAuth.PENDING,
    logout: () => {
        void 0;
    },
    enableLogs: false
});
/**
 * The `AuthWrapper` component handles user authentication and provides the `AuthContext` to its children.
 * It stores the authentication token in `localStorage` under the key `'te_auth_token'`,
 * which can be retrieved using the `getAccessToken` utility function.
 */
export const AuthWrapper = ({ renderChildrenWhileLoading = false, authUrl, appId, onLogout, onLoginSuccess, children, enableLogs = false, customerSignature, authConfigId, fallbackAuthUrl, logoutFromAllTabs = true }) => {
    const [authState, setAuthState] = useState(EAuth.PENDING);
    const logout = useAuthentication({
        authConfigId,
        authUrl,
        appId,
        customerSignature,
        setAuthState,
        appSpecificLoginFn: onLoginSuccess,
        appSpecificLogoutFn: onLogout,
        enableLogs,
        fallbackAuthUrl,
        logoutFromAllTabs
    });
    return (_jsx(AuthContext.Provider, { value: { authState, logout, enableLogs }, children: _jsxs("div", { className: "auth-loading--wrapper", children: [authState === EAuth.PENDING && (_jsx("div", { className: "auth-load-spinner", children: _jsx(Space, { size: "middle", children: _jsx(Spin, { size: "large" }) }) })), (renderChildrenWhileLoading || authState === EAuth.AUTHENTICATED) &&
                    children] }) }));
};
export { getAccessToken } from "./utils/tokenUtils";
